function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip88)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.2 17.6004C30.8075 17.6004 31.3 17.1079 31.3 16.5004C31.3 15.8929 30.8075 15.4004 30.2 15.4004C29.5925 15.4004 29.1 15.8929 29.1 16.5004C29.1 17.1079 29.5925 17.6004 30.2 17.6004Z",
  fill: "url(#paint500_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.4 11.7V11.6V4.5C31.4 2 29.4 0 27 0H4.5C2 0 0 2 0 4.4V20.6V22.8V26.9C0 29.3 2 31.3 4.4 31.3H27C29.4 31.3 31.4 29.3 31.4 26.9V21.7C31.4 21.1 30.9 20.7 30.4 20.7H30.3H2.3V4.4C2.3 3.2 3.3 2.2 4.5 2.2H27C28.2 2.2 29.2 3.2 29.2 4.4V11.5C29.2 12.1 29.7 12.6 30.3 12.6C30.9 12.7 31.3 12.2 31.4 11.7ZM29.1 22.9L29.2 27C29.2 28.2 28.2 29.2 27 29.2H4.5C3.3 29.2 2.3 28.2 2.3 27V22.9H29.1Z",
  fill: "url(#paint501_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6 27.4002C16.2075 27.4002 16.7 26.9077 16.7 26.3002C16.7 25.6927 16.2075 25.2002 15.6 25.2002C14.9925 25.2002 14.5 25.6927 14.5 26.3002C14.5 26.9077 14.9925 27.4002 15.6 27.4002Z",
  fill: "url(#paint502_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.60001 7.3998V15.7998C6.60001 16.3998 7.10001 16.9998 7.70001 16.9998C8.30001 16.9998 8.90001 16.4998 8.90001 15.7998V7.3998C8.90001 6.7998 8.40001 6.2998 7.70001 6.2998C7.00001 6.2998 6.60001 6.7998 6.60001 7.3998Z",
  fill: "url(#paint503_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 12.7996V15.8996C14.5 16.4996 15 17.0996 15.6 17.0996C16.2 17.0996 16.8 16.5996 16.8 15.8996V12.7996C16.8 12.1996 16.3 11.5996 15.6 11.5996C14.9 11.5996 14.5 12.0996 14.5 12.7996Z",
  fill: "url(#paint504_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.4 10.1004V15.8004C22.4 16.4004 22.9 17.0004 23.5 17.0004C24.1 17.0004 24.7 16.5004 24.7 15.8004V10.1004C24.7 9.50039 24.2 8.90039 23.5 8.90039C22.8 8.90039 22.4 9.40039 22.4 10.1004Z",
  fill: "url(#paint505_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint500_linear",
  x1: 30.2,
  y1: 15.4004,
  x2: 30.2,
  y2: 17.6004,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint501_linear",
  x1: 15.7,
  y1: 0,
  x2: 15.7,
  y2: 31.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint502_linear",
  x1: 15.6,
  y1: 25.2002,
  x2: 15.6,
  y2: 27.4002,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint503_linear",
  x1: 7.75001,
  y1: 6.2998,
  x2: 7.75001,
  y2: 16.9998,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint504_linear",
  x1: 15.65,
  y1: 11.5996,
  x2: 15.65,
  y2: 17.0996,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint505_linear",
  x1: 23.55,
  y1: 8.90039,
  x2: 23.55,
  y2: 17.0004,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip88"
}, /*#__PURE__*/React.createElement("rect", {
  width: 31.4,
  height: 31.4,
  fill: "white"
})));

function SvgBroadcast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/broadcast.157107f3.svg";
export { ForwardRef as ReactComponent };